// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2jFbz","name":"Header_name__yV12c","birthday":"Header_birthday__2hShZ","skeleton":"Header_skeleton__18PKN"};